var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "input-container" }, [
    _c("label", { attrs: { for: _vm.field } }, [_vm._v(_vm._s(_vm.label))]),
    _c(
      "div",
      { staticClass: "input-wrapper" },
      [
        _c("div", { staticClass: "input-holder" }, [
          _c("input", {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.newsletter[_vm.field],
                expression: "newsletter[field]"
              }
            ],
            class: [{ "input-error": _vm.errors.length > 0 }],
            attrs: {
              type: "text",
              id: _vm.field,
              placeholder: _vm.placeholder
            },
            domProps: { value: _vm.newsletter[_vm.field] },
            on: {
              focusout: _vm.validate,
              input: function($event) {
                if ($event.target.composing) return
                _vm.$set(_vm.newsletter, _vm.field, $event.target.value)
              }
            }
          }),
          _vm.errors.length > 0
            ? _c(
                "div",
                { key: _vm.$i18n.locale, staticClass: "errors" },
                _vm._l(_vm.errors, function(error, index) {
                  return _c("span", { key: index }, [
                    _vm._v(
                      " " +
                        _vm._s(
                          `${_vm.$t(
                            `controlPanel.landingPage.errors.${error.name}`,
                            error.min ? { min: error.min, max: error.max } : ""
                          )}`
                        ) +
                        " "
                    )
                  ])
                }),
                0
              )
            : _vm._e()
        ]),
        _c("Hint", { attrs: { label: "", hint: _vm.hint } })
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }